export default __webpack_public_path__ + "static/media/seo-services-360devpro.928a6629.svg";